const openLinkInNewTab = (url: string) => {
  return (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    window.open(url, '_blank');
  };
};

export { openLinkInNewTab };
